export const PERM = {
  // Organization
  ORG_DIV_EDIT:         "org_div_edit", // Organization > Division 편집
  ORG_EMP_EDIT:         "org_emp_edit", // Organization > Employee 편집
  ORG_REVIEWER_EDIT:    "org_reviewer_edit", // Organization > Reviewer 편집
  ORG_PERMISSION:       "org_permission", // Organization > Permission 접근

  // WorkingTimeTable
  WR_MGR_TAB:           "wr_mgr_tab",  // WorkingTimeTable > Work Record 타 유저 확인 탭
  WR_REPORT:            "wr_report",   // WorkingTimeTable > Report 탭 접근

  // Training
  TR_MGR_TAB:           "tr_mgr_tab", // Training > 매니저 탭

  // ProjectSetup
  PRJ_CONTRACT_REG:     "prj_contract_reg", // ProjectSetup > Contract Registration 탭 접근
  PRJ_ASSIGN_MW:        "prj_assign_mw", // ProjectSetup > MW 담당자 편집
  PRJ_ASSIGN_CO:        "prj_assign_co", // ProjectSetup > CO 담당자 편집
  PRJ_ASSIGN_DM:        "prj_assign_dm", // ProjectSetup > DM 담당자 편집
  PRJ_ASSIGN_SA:        "prj_assign_sa", // ProjectSetup > SA 담당자 편집
  PRJ_ASSIGN_PV:        "prj_assign_pv", // ProjectSetup > PV 담당자 편집
  PRJ_ASSIGN_QA:        "prj_assign_qa", // ProjectSetup > QA 담당자 편집
  PRJ_ASSIGN_RA:        "prj_assign_ra", // ProjectSetup > RA 담당자 편집

  // SalesManagement
  SALES_MGMT_EDIT:      "sales_mgmt_edit", // SalesManagement > Payment/Vendor 편집

  // MonthlyReport
  REPORT_STUDY_EDIT:        "report_study_edit",        // MonthlyReport > Study Status 편집
  REPORT_PROJECT_EDIT:      "report_project_edit",      // MonthlyReport > Project List 편집
  REPORT_PROJECT_COMPLETE:  "report_project_complete",  // MonthlyReport > ProjectList 전체완료 처리 (resp=2만)
  REPORT_EDIT_ALL:          "report_of_edit_all",       // MonthlyReport > OF/SRD/CEO 전체 프로젝트 입력 (기존 키 유지)

  // Feasibility Questionnaire
  // owner 행위(생성, 개요·질문 편집, 생명주기 전환, 초대·평가, 초대 Finalize, 리스크
  // 재정의 승인)는 SFQ_STUDY_EDIT 권한 + 스터디 owner(SFQ.createdBy)인지로 결정된다.
  // reviewer 행위(내부검토 승인/반려, 발행 승인/반려)는 스터디에 지정된
  // reviewer(SFQ.reviewerEmployeeNo)인지로 결정된다 — 자격은 SFQ_REVIEWER 권한.
  // CRA 작업(사이트 발송·코멘트·평가)은 SFQ_CRA_EDIT 권한 + 그 스터디에 배정(SFQ_CRA)됐는지.
  SFQ_CRA_EDIT:             "sfq_cra_edit",             // SFQ CRA 배정 자격 (사이트 발송·평가)
  SFQ_QA_VIEW:              "sfq_qa_view",              // SFQ 조회 (QA)
  SFQ_ADMIN:                "sfq_admin",                // SFQ owner/reviewer/CRA 지정·변경 (Admin)
  SFQ_STUDY_EDIT:           "sfq_study_edit",           // SFQ 생성 + owner 전권 (CPM/Head)
  SFQ_REVIEWER:             "sfq_reviewer",             // SFQ reviewer 지정 자격 (CPM/Head)
};

export const REPORT_EDIT_ALL_DIVISIONS = ["OF", "SRD", "CEO"];

// SFQ는 조회조차 권한이 필요하다 — 이 중 하나가 없으면 메뉴도 화면도 열리지 않는다.
// QA는 조회 전용, CRA는 배정된 스터디만, owner/reviewer/Admin의 쓰기 자격은 화면 안에서 별도로 걸린다.
export const SFQ_ACCESS = [
  PERM.SFQ_QA_VIEW, PERM.SFQ_CRA_EDIT, PERM.SFQ_ADMIN,
  PERM.SFQ_STUDY_EDIT, PERM.SFQ_REVIEWER,
];

// 전체 조회 자격: 순수 CRA만 배정된 스터디로 제한되고, 나머지는 전체를 본다.
export const SFQ_SEES_ALL = [
  PERM.SFQ_QA_VIEW, PERM.SFQ_ADMIN, PERM.SFQ_STUDY_EDIT, PERM.SFQ_REVIEWER,
];
